'use strict';

export default class CategoriasService {

    /*@ngInject*/
    constructor($http, CATEGORIAS_URL){
        Object.assign(this, {$http, CATEGORIAS_URL});
    }

    getCategorias(){
        return this.$http.get(this.CATEGORIAS_URL);
    }

    guardarCambiosCategorias(categorias) {
        return this.$http.put(this.CATEGORIAS_URL, categorias);
    }

    cambiarNombreCategoria(oldCat, newCat){
        return this.$http.put(this.CATEGORIAS_URL + '/categoria', {oldCategoria:oldCat, newCategoria: newCat});
    }

    cambiarNombreSubcategoria(cat, oldSubcat, newSubcat){
        return this.$http.put(this.CATEGORIAS_URL + '/subcategoria', {categoria: cat, oldSubcategoria: oldSubcat, newSubcategoria: newSubcat});
    }

}


// WEBPACK FOOTER //
// ./client/app/categorias-route/categorias-route.service.js